import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, catchError } from 'rxjs';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private snackbarService: NotificationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 500 || error.status === 503) {
          this.snackbarService.showSnackBar('An error occurred. Please try again later.');
        } else if (error.status === 401) {
          this.router.navigate(['/admin/login']);
        } else if (error.status === 403) {
          this.router.navigate(['/forbidden']);
        } else {
          this.snackbarService.showSnackBar('An unexpected error occurred.');
          console.error('An unexpected error occurred:', error);
        }

        return throwError(() => error);
      })
    );
  }
}
